export default __webpack_public_path__ + "static/media/BG.56a19c67.jpg";